import React from "react";
import "../../styles/TopFoods.css";

const TopFoods = ({ foods = [] }) => {

    return (

        <div className="report-card">

            <div className="card-header">

                <h3>Top Selling Foods</h3>

            </div>

            <table className="report-table">

                <thead>

                    <tr>

                        <th>Food</th>

                        <th>Sold</th>

                        <th>Revenue</th>

                    </tr>

                </thead>

                <tbody>

                    {foods.length === 0 ? (

                        <tr>

                            <td colSpan="3">

                                No Foods Found

                            </td>

                        </tr>

                    ) : (

                        foods.map((food) => (

                            <tr key={food._id}>

                                <td>{food.foodName}</td>

                                <td>{food.quantity}</td>

                                <td>₹{food.revenue}</td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

};

export default TopFoods;